import React from 'react';
import PropTypes from 'prop-types';

import Medialib from 'api/resources/medialib';
import getPrefix from 'utils/getPrefix';
import { processErrorByAlert } from 'utils/getErrors';

import ButtonLoader from 'components/Loader/ButtonLoader';
import SecondaryButton from 'styled/Buttons/SecondaryButton';
import SectionHeader from 'styled/Page/SectionHeader';

/* eslint-disable-next-line import/no-cycle */
import FieldWrapper from './FieldWrapper';
import FileName from './FileName';

class ChooseFileField extends React.Component {
  state = {
    loading: false,
  }

  handleFileChange = async (e) => {
    if (e.target.files[0]) {
      this.setState({ loading: true });

      try {
        const response = await Medialib.post({
          upload: e.target.files[0],
          prefix: getPrefix(this.props.mediaType),
          isAr: this.props.isAr,
        });

        this.setState({ loading: false });

        this.props.onLoad(response.data[0]);
      } catch (err) {
        this.setState({ loading: false });
        processErrorByAlert(err);
      }
    }
  }

  handleClick = (e) => {
    e.target.value = null;
  }

  render() {
    return (
      <FieldWrapper>
        <SectionHeader style={{ display: 'block', width: '100%' }}>{this.props.label}</SectionHeader>

        {this.props.name
          ? <FileName>{this.props.name}</FileName>
          : <span style={{ opacity: 0.4 }}>Файл не выбран</span>
        }

        <SecondaryButton
          as="label"
          style={{ marginLeft: 'auto' }}
          disabled={this.props.disabled}
        >
          {!this.state.loading && (this.props.name ? 'изменить' : 'выбрать')}

          {this.state.loading && <ButtonLoader />}

          <input
            type="file"
            style={{ display: 'none' }}
            onChange={this.handleFileChange}
            accept={this.props.accept}
            disabled={this.props.disabled}
            onClick={this.handleClick}
          />
        </SecondaryButton>
      </FieldWrapper>
    );
  }
}

ChooseFileField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  accept: PropTypes.string,
  mediaType: PropTypes.string,
  disabled: PropTypes.bool,
  onLoad: PropTypes.func,
  isAr: PropTypes.bool,
};

ChooseFileField.defaultProps = {
  label: '',
  name: '',
  accept: '',
  mediaType: '',
  disabled: false,
  onLoad: () => {},
  isAr: false,
};

export default ChooseFileField;
